// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/PlatformLogo/PlatformLogo.less
// module id = 1069
// module chunks = 0